var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticClass:"header-title-btn"},[_vm._v("<")]),_c('div',{staticClass:"header-title"},[_vm._v("我是头部")])])
}]

export { render, staticRenderFns }